module.exports = __webpack_public_path__ + "media/images/menu/nebulae-80d395feeffeae8efa7a12ce9ceac6bf.jpg";